// extracted by mini-css-extract-plugin
export default {"tableCell":"style_tableCell__1SIO4"};